/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class Period {
    period_key: number;
    dueDate: Date;
    extensionDate: Date;
    biweeklyDate: Date;
    sup1Date: Date;
    sup2Date: Date;
}
